import axiosInstance from "./axios.config";

export default async function addLeagues(league_name, description) {
  try {
    const response = await axiosInstance.post("/leagues", {
      league_name,
      description,
    });

    return response.data;
  } catch (error) {
    throw error?.response?.data?.message || "An error occurred during login";
  }
}
